<nd-date-picker
  [id]="idName"
  [formGroup]="parentForm"
  attr-for-value="value"
  [i18n]="i18n"
  [attr.min]="minDate"
  [attr.max]="maxDate"
  #ndDatePicker
  class="toolbar-item custom-date-picker sif-btn cursor-pointer"
  tooltip-inverse
  rel="tooltip"
  [value]="initialDateValue"
  [attr.tooltip-content]="tooltipValue"
>
  <nd-input
    auto-validate
    ngDefaultControl
    [attr.formControlName]="controlName"
    #ndDatePickerInput
    id="date-input"
    slot="text"
    [label]="label"
    [class]="className"
    [placeholder]="placeholder"
  ></nd-input>
</nd-date-picker>
